'use client'

import { useEffect, useState } from 'react'
import { EVENT_DATES } from '../config'
import { SessionRegistrationButton } from '../SessionRegistrationButton'

export function StickyRegistrationBar() {
  const [heroHasPassed, setHeroHasPassed] = useState(false)
  const [finalCtaHasArrived, setFinalCtaHasArrived] = useState(false)

  useEffect(() => {
    const hero = document.getElementById('session-hero')
    const finalCta = document.getElementById('session-final-cta')

    if (typeof IntersectionObserver === 'undefined') {
      return
    }

    const heroObserver = new IntersectionObserver(([entry]) => {
      setHeroHasPassed(
        !entry.isIntersecting && entry.boundingClientRect.bottom < 0
      )
    })

    const finalCtaObserver = new IntersectionObserver(([entry]) => {
      setFinalCtaHasArrived(
        entry.isIntersecting ||
          entry.boundingClientRect.top < window.innerHeight
      )
    })

    if (hero) heroObserver.observe(hero)
    if (finalCta) finalCtaObserver.observe(finalCta)

    return () => {
      heroObserver.disconnect()
      finalCtaObserver.disconnect()
    }
  }, [])

  const isVisible = heroHasPassed && !finalCtaHasArrived

  return (
    <aside
      aria-label="The Session registration"
      aria-hidden={!isVisible}
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/15 bg-[#1d0505] text-white transition-[opacity,transform,visibility] duration-200 motion-reduce:transition-none ${
        isVisible
          ? 'visible translate-y-0 opacity-100'
          : 'invisible translate-y-full opacity-0'
      }`}
    >
      <div className="mx-auto flex max-w-(--breakpoint-xl) items-center justify-between gap-4 px-4 py-2.5 sm:px-6 sm:py-3">
        <div className="flex min-w-0 items-center gap-3">
          <span
            aria-hidden="true"
            className="hidden h-9 w-px shrink-0 bg-vi-red sm:block"
          />
          <div className="min-w-0">
            <p className="truncate text-sm font-bold sm:text-base">
              The Session 2027
            </p>
            <p className="hidden text-sm text-white/70 sm:block">
              {EVENT_DATES} · London Heathrow
            </p>
          </div>
        </div>
        <SessionRegistrationButton
          placement="sticky"
          size="sm"
          className="shrink-0"
        >
          Register now
        </SessionRegistrationButton>
      </div>
    </aside>
  )
}
